import React from 'react';

interface GooglePlayIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const GooglePlayIcon: React.FC<GooglePlayIconProps> = ({
  width = 25,
  height = 25,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_380_1666"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="2"
        width="20"
        height="21"
      >
        <path
          d="M23.4753 11.2503C24.4666 11.7958 24.4666 13.2042 23.4753 13.7497L7.62209 22.4734C6.65666 23.0046 5.46875 22.3152 5.46875 21.2237V3.77636C5.46875 2.68482 6.65666 1.99543 7.62209 2.52668L23.4753 11.2503Z"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_380_1666)">
        <path
          d="M5.96463 22.3029L15.8534 12.3586L6.12749 2.57812C5.73948 2.82686 5.46875 3.2563 5.46875 3.7774V21.2247C5.46875 21.6693 5.6658 22.0471 5.96463 22.3029Z"
          fill="url(#paint0_linear_380_1666)"
        />
        <path
          d="M23.4749 11.2498C24.4662 11.7952 24.4662 13.2036 23.4749 13.7491L19.4754 15.9499L15.853 12.357L19.2908 8.94727L23.4749 11.2498Z"
          fill="url(#paint1_linear_380_1666)"
        />
        <path
          d="M19.4759 15.9503L15.8534 12.3574L5.9646 22.3017C6.39946 22.6741 7.04985 22.788 7.62208 22.4731L19.4759 15.9503Z"
          fill="url(#paint2_linear_380_1666)"
        />
        <path
          d="M6.1272 2.57707L15.8531 12.3576L19.2908 8.94789L7.62178 2.52668C7.11724 2.24905 6.55196 2.30479 6.1272 2.57707Z"
          fill="url(#paint3_linear_380_1666)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_380_1666"
          x1="12.2476"
          y1="8.49623"
          x2="5.52427"
          y2="15.2748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C3FF" />
          <stop offset="1" stopColor="#1BE2FA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_380_1666"
          x1="15.853"
          y1="12.357"
          x2="24.7953"
          y2="12.357"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCE00" />
          <stop offset="1" stopColor="#FFEA00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_380_1666"
          x1="5.75722"
          y1="23.5156"
          x2="17.6523"
          y2="13.9791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DE2453" />
          <stop offset="1" stopColor="#FE3944" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_380_1666"
          x1="6.33382"
          y1="1.48545"
          x2="17.654"
          y2="10.7316"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#11D574" />
          <stop offset="1" stopColor="#01F176" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GooglePlayIcon;
